<template>
  <header-menu />
  <div class="forgetPassword">
    <van-field
      v-model="data.phone"
      type="number"
      class="textCorol"
      :clearable="true"
      placeholder="请输入手机号"
      label-align="top"
      maxlength="11"
    />
    <van-field
      v-model="data.phoneCode"
      maxlength="6"
      type='number'
      class="textCorol"
      :clearable="true"
      placeholder="请输入验证码"
      label-align="top"
    >
      <template #button>
        <div class="btn" @click="data.getCode">
          {{
            store.codeTimeFlag1 ? "获取验证码" : store.codeTime1 + "秒后重发"
          }}
        </div>
      </template>

    </van-field>
    <input type="text" style='height:0;border:none;position: absolute;'>
    <input type="password" style='height:0;border:none;position: absolute;'>
    <van-field
      v-model="data.password"
      :type="data.passwordType"
      @input="data.input('password')"
      class="textCorol"
      :clearable="true"
      placeholder="请设置密码，6-20位字母和数字"
      label-align="top"
      maxlength="20"
      minlength="6"
    >
      <template #button>
        <div class="switch">
          <img
            @click="data.passwordType = ''"
            v-if="data.passwordType === 'password'"
            src="@/assets/hideImg.png"
            alt=""
          />
          <img
            v-else
            @click="data.passwordType = 'password'"
            src="@/assets/showImg.png"
            alt=""
          />
        </div>
      </template>
    </van-field>
    <van-field
      v-model="data.copyPassword"
      @input="data.input('copyPassword')"
      :type="data.copyPasswordType"
      class="textCorol"
      :clearable="true"
      placeholder="再次输入密码"
      label-align="top"
      maxlength="20"
      minlength="6"
    >
      <template #button>
        <div class="switch">
          <img
            @click="data.copyPasswordType = ''"
            v-if="data.copyPasswordType === 'password'"
            src="@/assets/hideImg.png"
            alt=""
          />
          <img
            v-else
            @click="data.copyPasswordType = 'password'"
            src="@/assets/showImg.png"
            alt=""
          />
        </div>
      </template>
    </van-field>
  </div>
  <div class="bottom">
    <div class="btn" @click="data.quitResetting">确认重置</div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
  onActivated,
} from "vue";
import { useRoute, useRouter } from "vue-router";

import { useCounterStore } from "@/store";

import { resetpassword,sendSmsCode } from "@/api/login";

import { showSuccessToast, showFailToast } from "vant";

import cross from "@/assets/cross.png";

import surres from "@/assets/surres.png";

import headerMenu from "@/components/headerMenu.vue";

defineComponent({
  name: "",
});

const store = useCounterStore();
const route = useRoute();
const router = useRouter();
const data = reactive({});

data.phone = "";
data.phoneCode = "";
data.password = "";
data.copyPassword = "";
data.passwordType = "password";
data.copyPasswordType = "password";

data.input = (e) => {
  data[e] = data[e].trim();
};

// 获取验证码
data.getCode = () => {
  const phoneReg = /^1[3-9]\d{9}$/;
  if (data.phone && phoneReg.test(data.phone)) {
    if (store.codeTimeFlag1) {
      sendSmsCode({ phone: data.phone, type: 2 }).then((res) => {
        if (res.code === 200) {
          showFailToast({
            message: res.message,
            icon: surres,
          });
          store.codeTimeFunction1();
        }
      });
    }
  } else {
    showFailToast({
      message: "请输入正确的手机号",
      icon: cross,
    });
  }
};

data.quitResetting = () => {
  const phoneReg = /^1[3-9]\d{9}$/;
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/;
  if (!data.phone) {
    showFailToast({
      message: "请输入手机号",
      icon: cross,
    });
    return false;
  }
  if (!phoneReg.test(data.phone)) {
    showFailToast({
      message: "请输入正确的手机号",
      icon: cross,
    });
    return false;
  }
  if (!data.phoneCode) {
    showFailToast({
      message: "请输入验证码",
      icon: cross,
    });
    return false;
  }
  if (!data.password) {
    showFailToast({
      message: "请输入新密码",
      icon: cross,
    });
    return false;
  }
  if (data.password.length < 6) {
    showFailToast({
      message: "请输入\n6-20位密码",
      icon: cross,
    });
    return false;
  }
  if (!passwordRegex.test(data.password)) {
    showFailToast({
      message: "密码需包含字母和数字",
      icon: cross,
    });
    return false;
  }
  if (data.password !== data.copyPassword) {
    showFailToast({
      message: "两次输入的密码不一致",
      icon: cross,
    });
    return false;
  }
  resetpassword({
    phone:data.phone,
    new:data.password,
    code:data.phoneCode
  }).then(res=>{
    if (res.code === 200) {
      showFailToast({
        message: "重置成功",
        icon: surres,
      });
      router.replace({
        name:'loginIndex'
      })
    }
  })
};

onActivated(() => {
  data.phone = "";
  data.phoneCode = "";
  data.password = "";
  data.copyPassword = "";
  data.passwordType = "password";
  data.copyPasswordType = "password";
});
onBeforeMount(() => {});
onMounted(() => {});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.forgetPassword {
  padding-top: 52px;
}
.van-cell {
  margin: 0 64px;
  width: auto;
  height: 88px;
  line-height: 88px;
  background: #323647;
  border-radius: 24px;
  margin-top: 48px;
  padding: 0 32px;
  color: #f7f5ff;
  font-size: 28px;
  ::v-deep().van-field__body {
    .van-field__control {
      color: #f7f5ff;
    }
    .van-icon {
      font-size: 30px;
    }
  }
  .btn {
    font-weight: 400;
    color: #8368fc;
  }
}
.van-cell:after {
  display: none;
}
.bottom {
  margin: 0 64px;
  margin-top: 100px;
  text-align: center;
  .btn {
    background: #8368fc;
    border-radius: 44px;
    color: #ffffff;
    font-size: 34px;
    padding: 20px 0;
  }
}
.switch {
  display: flex;
  align-items: center;
  img {
    width: 48px;
    height: 48px;
  }
}
</style>
